@layer core.atoms {
  .phxsg-divider {
    --_comp-divider-width: var(--comp-divider-width, 100%);
    --_comp-divider-spacing: var(--this-divider-spacing, var(--comp-divider-spacing));
    --_comp-divider-color: var(--this-divider-color, var(--comp-divider-color));

    width: var(--_comp-divider-width);
    margin-block: var(--_comp-divider-spacing);

    border-top-width: 1px;
    border-style: solid;
    border-color: var(--_comp-divider-color);
  }

  .phxsg-divider--vertical {
    --_comp-divider-height: var(--comp-divider-height, 100%);

    width: 1px;
    height: var(--_comp-divider-height);
    margin-block: 0;
    margin-inline: var(--_comp-divider-spacing);

    border-top: none;
    border-left-width: 1px;
  }
}
